import { render, staticRenderFns } from "./JSelectMultiple.vue?vue&type=template&id=a37e67d6"
import script from "./JSelectMultiple.vue?vue&type=script&lang=js"
export * from "./JSelectMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a37e67d6')) {
      api.createRecord('a37e67d6', component.options)
    } else {
      api.reload('a37e67d6', component.options)
    }
    module.hot.accept("./JSelectMultiple.vue?vue&type=template&id=a37e67d6", function () {
      api.rerender('a37e67d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/JSelectMultiple.vue"
export default component.exports